package dev.youndie.site.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initSborkaPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("sborka.md", FrontMatterElement.Builder { addScalar("title", "sborka"); addScalar("searchTitle", "Gradle conventions and a ktlint rule set for Kotlin — sborka"); addScalar("description", "Gradle conventions as a plugin, and kapkan beside them: ktlint rules that each encode one defect the stack paid for, with no configuration and suppressions that have to say why."); addScalar("library", "sborka"); addScalar("post", "/blog/kapkan"); }))
}

@Page("/sborka")
@Layout(".components.layouts.LibraryLayout")
@Composable
fun SborkaPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("why-it-exists") }) {
        org.jetbrains.compose.web.dom.Text("Why it exists")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Nineteen Gradle builds had arrived at five ways of publishing, four wirings of ktlint and eleven different ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text(".editorconfig")
        }
        org.jetbrains.compose.web.dom.Text(" files. sborka is one plugin that settles those — the coordinate, the toolchain, publishing, the formatter, the test gate — and one line in ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("gradle.properties")
        }
        org.jetbrains.compose.web.dom.Text(" instead of dozens of lines of Kotlin per repository.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("kapkan")
        }
        org.jetbrains.compose.web.dom.Text(" is the second half: a ktlint rule set the conventions hand to ktlint, where each rule encodes one class of defect found in this stack rather than an opinion about style.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("one-line-per-decision") }) {
        org.jetbrains.compose.web.dom.Text("One line per decision")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code(attrs = { classes("language-properties") }) { org.jetbrains.compose.web.dom.Text("""sborka.group=io.github.youndie
sborka.jvmToolchain=25
sborka.jvmFloor=25
sborka.junitVersion=6.1.3
""") } }
    org.jetbrains.compose.web.dom.H2(attrs = { id("the-gate-that-reads-the-results") }) {
        org.jetbrains.compose.web.dom.Text("The gate that reads the results")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("sborka.test")
        }
        org.jetbrains.compose.web.dom.Text(" compares the ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("@Test")
        }
        org.jetbrains.compose.web.dom.Text(" methods a module declares with what JUnit reported. A test whose last expression returns a value is not a test — JUnit does not run it and does not warn — and three of them were found this way in one repository, two months old, one covering a defect that could zero a subscriber's remaining allowance.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Native and browser suites get the smaller half of the same question: a suite that ran nothing does not pass.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("what-kapkan-catches") }) {
        org.jetbrains.compose.web.dom.Text("What kapkan catches")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Three ktlint rules, each with the item it was found in — a platform's own package imported into common code, a failure nothing reads, code asking the machine it happens to run on what time it is — plus a guard that makes every suppression say why, and ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("kapkanJoins")
        }
        org.jetbrains.compose.web.dom.Text(": the declarations nothing outside their own file mentions and the functions nothing calls.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("There is no configuration. A rule is in the set or it is not, and the only knob is a suppression that has to say why.")
    }
}
